import React from "react";
import { Routes as RouterRoutes, Route } from "react-router-dom";
import ErrorBoundary from "./components/ErrorBoundary";
import NotFound from "./pages/NotFound";
import LanguageWrapper from "./components/LanguageWrapper";

import AboutCompany from './pages/about-company';
import HomepageHeroServices from './pages/homepage-hero-services';
import PosaoPage from './pages/posao';
import AdminPage from './pages/admin';
import MiStorePage from './pages/mi-store';

const Routes = () => {
  return (
    <ErrorBoundary>
      <RouterRoutes>
        {/* 1. Rute sa prefiksom jezika (npr. /en/mi-store ili /sr/mi-store) */}
        <Route path="/:lang" element={<LanguageWrapper />}>
          <Route index element={<HomepageHeroServices />} />
          <Route path="about" element={<AboutCompany />} />
          <Route path="job" element={<PosaoPage />} />
          <Route path="xiaomi" element={<MiStorePage />} />
          <Route path="homepage-hero-services" element={<HomepageHeroServices />} />
        </Route>

        {/* 2. Rute bez prefiksa (default na srpski preko LanguageWrapper-a) */}
        <Route path="/" element={<LanguageWrapper />}>
          <Route index element={<HomepageHeroServices />} />
          <Route path="about" element={<AboutCompany />} />
          <Route path="job" element={<PosaoPage />} />
          <Route path="xiaomi" element={<MiStorePage />} />
          <Route path="homepage-hero-services" element={<HomepageHeroServices />} />
        </Route>

        {/* Admin i ostalo van LanguageWrapper-a ako ne treba prevod */}
        <Route path="/admin" element={<AdminPage />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
    </ErrorBoundary>
  );
};

export default Routes;